import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import BonusRecord from "./schema/bonus-record";
import ICFreespinRecord from "./schema/freespin-record";
import gameState from "slotworks/model/game-state";
import betModel from "slotworks/model/bets/bet-model";
import Logger = require("js-logger");
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";

class ICBonusRecordBuilder {

    public filter(data: any): boolean {
        let bonusSchema: BonusSchema;

        if (data && data.data) {
            bonusSchema = data.data as BonusSchema;
        }

        const isRecovery = bonusSchema && bonusSchema.OPEN !== undefined && !GameState.getCurrentGame().getCurrentRecord();
        const bonusResultExists = bonusSchema && bonusSchema.RESULTS !== undefined;
        const isBonusResult = bonusResultExists && bonusSchema.RESULTS.game.indexOf("BONUS") > -1;
        const isBonusOpen = bonusResultExists && bonusSchema.RESULTS.next_game && bonusSchema.RESULTS.next_game.indexOf("BONUS") > -1;

    //    return (isBonusOpen || isBonusResult) && !isRecovery;  
        return (isBonusResult) && !isRecovery;  
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let bonusSchema: BonusSchema;

        if (data && data.data) {
            bonusSchema = data.data as BonusSchema;
        }

        let bonusData;
        if (bonusSchema.OPEN || bonusSchema.RESULTS.game.toLowerCase().indexOf("base") > -1) {
            if (bonusSchema.OPEN) {
                bonusData = bonusSchema.OPEN;
            } else {
                bonusData = {
                    ...bonusSchema.RESULTS,
                    state: bonusSchema.RESULTS.next_game_state,
                    game: "BONUS"
                };
            }
        } else {
            bonusData = bonusSchema.RESULTS;
        }

        RevolverModel.game = bonusData.game;
        RevolverModel.bet = JSON.stringify(bonusData.bet_state);        

        const bonusRecord = new BonusRecord();   
        bonusRecord.multiplier = bonusData.state.multiplier;
        bonusRecord.creditsWon = bonusData.state.total_win_cash;    
        bonusRecord.awardedMultiplier = bonusData.state.awardedMultiplier;
        bonusRecord.bonusMultipliers = bonusData.state.bonusMultipliers;

        const win = parseFloat(bonusData.state.total_win_cash as any);
        gameplay.totalCreditsWon += win;
        gameState.updateNetPosition(win);
        if(gameplay.inFreespinsGame) {
            gameplay.totalFreespinsCreditsWon += win;
        }

        if(campaignsModel.isFreespinsActive()) {
            campaignsModel.freespins.totalWin += win;
        }

        // bonus in freespins recovery
        if(bonusSchema.OPEN && RevolverModel.isFreespin((bonusData.state as any).triggering_game)) {
            bonusRecord.recoversFreespins = true;
        }

        if(bonusRecord.awardedMultiplier === 2000 || bonusRecord.awardedMultiplier === bonusRecord.creditsWon
            || bonusRecord.creditsWon / betModel.getTotalBet() >= 2000) // server bug, please fix it
            bonusRecord.isJackpotWon = true;

        const records = [];
        records.push(bonusRecord);

        if (RevolverModel.isFreespin(bonusData.next_game)) {
            const next_game = bonusData.next_game_state as any;

            if(next_game.total > 0 && next_game.total === next_game.remain) {
                bonusRecord.freespinsTriggered = true;
                bonusRecord.freespinsWon = next_game.total;
            } else
                bonusRecord.inFreespins = true;
        } else {            
            let inFreespins = false;
            const current = gameState.getCurrentGame().records;
            for(let r of current) {
                if(r instanceof ICFreespinRecord) {
                    inFreespins = true;
                    break;
                }
            }
            if(inFreespins) {
                const dummy = new ICFreespinRecord();
                this.resetDummy(dummy);
                dummy.isFreespinsComplete = true;                                
                records.push(dummy);                
            }
        }
        return records;
    }

    private resetDummy(dummy: ICFreespinRecord) {
        dummy.creditsWon = 0;
        dummy.reelset = [];
        dummy.grid = [];
        dummy.stops = [];
        dummy.results = [];
        dummy.beenPaid = false;
    }
}

export interface BonusSchema {
    OPEN: BonusResult;
    RESULTS: BonusResult;
}

interface BonusResult {
    game: string;
    next_game: string;
    next_game_state: BonusState;
    state: BonusState;
    bet_state: any;
    total_win_cash: number;
}

interface BonusState {
    awardedMultiplier: number;
    bonusMultipliers: number[];
    is_complete: boolean;
    multiplier: number;
    rounds: number;
    spin_pending: boolean;
    total_win_cash: number;    
}

export default new ICBonusRecordBuilder();